import { Injectable } from '@angular/core';

@Injectable()
export class Utils {
  public static convertMilliSecondsToDate(milliSeconds: string): string[] {
    const date: string[] = new Date(milliSeconds).toLocaleDateString().split('/');
    return date;
  }

  public static isAdmin(): boolean {
    if (localStorage.getItem('user') === 'admin') {
      return true;
    }
    return false;
  }

  public static getDynamicStepSize(arr: any): number {
    const maxValue: number = Math.floor(Math.max.apply(null, arr) / 10);
    const stepsize = Math.pow(10, maxValue.toString().length);
    return stepsize;
  }
}
